<template>
  <v-btn
    color="primary"
    @click="event"
    :disabled="isDisabled"
    :loading="isLoading"
  >
    {{ buttonName }}
  </v-btn>
</template>
<script>
  export default {
    props: [
      'buttonName',
      'event',
      'isDisabled',
      'isLoading'
    ],
    name: 'EventButton',
  }
</script>